import React, { useEffect, useState } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Wordmark } from "./Brand";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Industries", href: "#validation" },
  { label: "Why Us", href: "#why-us" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled ? "py-3" : "py-5"
      }`}
    >
      <div className="mx-auto max-w-7xl px-5 lg:px-10 flex items-center justify-between gap-4">
        {/* Left: brand */}
        <div className="flex items-center">
          <Wordmark />
        </div>

        {/* Center: floating pill nav (desktop) */}
        <nav
          className="hidden lg:flex items-center gap-1 bg-white/85 backdrop-blur-xl border border-ink-50/[0.06] rounded-full px-3 py-2 shadow-[0_10px_40px_-20px_rgba(11,14,20,0.18)]"
          data-testid="pill-nav"
        >
          {LINKS.map((l) => (
            <a
              key={l.label}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="px-4 py-1.5 text-[14px] font-medium text-ink-200 hover:text-ink-50 rounded-full hover:bg-ink-50/[0.04] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        {/* Right: CTA */}
        <div className="hidden lg:block">
          <a
            href="#contact"
            data-testid="header-cta"
            className="btn-pill-dark"
          >
            Book Consultation
            <ArrowUpRight size={16} />
          </a>
        </div>

        {/* Mobile toggle */}
        <button
          aria-label="Toggle navigation"
          data-testid="header-mobile-toggle"
          onClick={() => setOpen((s) => !s)}
          className="lg:hidden inline-flex items-center justify-center w-10 h-10 rounded-full bg-white border border-ink-50/[0.08] shadow-sm"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {/* Mobile panel */}
      {open && (
        <div
          data-testid="mobile-panel"
          className="lg:hidden mx-5 mt-3 bg-white border border-ink-50/[0.06] rounded-3xl shadow-xl p-4"
        >
          <div className="flex flex-col">
            {LINKS.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className="px-4 py-3 text-[15px] font-medium text-ink-100 hover:bg-ink-50/[0.04] rounded-2xl"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta"
              className="mt-2 btn-pill-dark justify-center"
            >
              Book Consultation
              <ArrowUpRight size={16} />
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;
